import * as React from 'react';
import { Button, ButtonTheme, ButtonColor } from '@cian/button-component';
import * as styles from './index.css';
import { OutsideClick } from '@cian/components';
import { ComplaintContainer } from '../complaint/container';
import { IGetProductsParams } from '../../tracking/hide_offer';

export interface IHiddenBlockStoreButtonsProps {
  isComplainOpened: boolean;
  productParams?: IGetProductsParams;
}

export interface IHiddenBlockDispatchButtonsProps {
  toggleComplainPopup(isOpened: boolean): () => void;
  restoreOffer(): void;
}

type IHiddenBlockButtonsProps = IHiddenBlockStoreButtonsProps & IHiddenBlockDispatchButtonsProps;

export class HiddenBlockButtons extends React.PureComponent<IHiddenBlockButtonsProps, {}> {
  public render() {
    const { isComplainOpened, toggleComplainPopup, restoreOffer } = this.props;

    return (
      <div className={styles['buttons-outer']}>
        <span className={styles['complaint-outer']}>
          <Button onClick={toggleComplainPopup(true)} theme={ButtonTheme.Ghost} color={ButtonColor.Danger}>
            Пожаловаться
          </Button>
          {isComplainOpened && (
            <OutsideClick onOutsideClick={toggleComplainPopup(false)}>
              <div className={styles['tooltip']}>
                <ComplaintContainer handleOutsideClick={toggleComplainPopup(false)} />
              </div>
            </OutsideClick>
          )}
        </span>
        <Button onClick={restoreOffer} theme={ButtonTheme.Ghost}>
          Восстановить
        </Button>
      </div>
    );
  }
}
